import { useMemo } from "react";

export default function useReservationsSearch(rooms, query) {
  const allReservations = useMemo(() => {
    const result = [];

    rooms.forEach((room) => {
      [...(room.studentSlots || []), ...(room.teacherSlots || [])].forEach(
        (slot) => {
          if (!slot.reservedBy) return;

          result.push({
            userId: slot.reservedBy.id,
            name: slot.reservedBy.name,
            roomName: room.name,
            endTime: slot.endTime,
            type: room.teacherSlots?.includes(slot) ? "Lehrperson" : "Schüler",
          });
        },
      );
    });

    return result;
  }, [rooms]);

  const result = useMemo(() => {
    if (!query.trim()) return [];

    const lower = query.toLowerCase();

    return allReservations.filter((r) => r.name.toLowerCase().includes(lower));
  }, [query, allReservations]);

  return {
    allReservations,
    result,
  };
}
